import moment from 'moment';
import request from './api';
import { API_PROFILE_CMS } from '../constants/api';

const GroupDefaultParams = {
  direction: 'ASC',
  orderBy: 'NAME',
  size: 15,
  page: 0
};

const getFilterServiceFormat = date => moment(date).format('YYYY-MM-DD');

const paramsOptions = (query, obj) => {
  let options = query;
  Object.entries(obj).map(([key, value]) => {
    if (value !== '') {
      if (key === ('weekStartDateInit' || 'weekStartDateEnd')) {
        options += `&${key}=${getFilterServiceFormat(value)}`;
      } else {
        options += `&${key}=${value}`;
      }
    }
    return options;
  });
  return options;
};

export const getUsersByGroupId = id =>
  request(`${API_PROFILE_CMS}/groups/containusers?groupId=${id}`, {
    method: 'GET'
  });

export const getGroups = (objParams = GroupDefaultParams) => {
  const obj = { ...GroupDefaultParams, ...objParams };
  return request(`${API_PROFILE_CMS}/${paramsOptions('groups?', obj)}`);
};

// export const getGroupList = ids =>
// request(`${apiProfiles}groups?ids=${ids}`, { method: 'GET' });
// export const createGroup = group =>
// request(`${apiProfiles}groups`, {
// data: group,
// method: 'POST'
// });
